import { postRequest } from '@/utils/request';
import { getHost } from '@/utils/utils';

// const host = getHost('device');
// let host;
// getHost('device').then(h => {
//   host = h;
// });

// 查询用户客群
export async function queryCustomerGroupOfUser(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/homepage/customerGroup/query`, data);
}

export async function scanPage(data) {
  const host = await getHost('device');
  return postRequest(`${host}/v3/activity/user/page/scan`, data);
}
